module.exports = __webpack_public_path__ + "static/trigger-1c6cf9d0a4e239ee90fd65f054e57795.gif";